const circles = document.querySelectorAll<HTMLElement>(".percentage-circle");
const obs = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      const circle = entry.target as HTMLElement;

      if (entry.isIntersecting) {
        const strokeDasharray =
          getComputedStyle(
            circle.querySelector<HTMLElement>(
              ".percentage-circle__track--teal"
            )!
          ).strokeDasharray || "0";
        const percentage = circle.dataset.value?.replace("%", "") || "0";
        const dashInt = parseInt(strokeDasharray);
        const progress = dashInt - (dashInt / 100) * parseInt(percentage);

        circle.style.setProperty("--_percentage-progress", progress.toString());

        obs.unobserve(circle);
      }
    }
  },
  {
    threshold: 1,
  }
);

for (const circle of circles) {
  obs.observe(circle);
}
